/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const query =
  /* GraphQL */ `query Query($filters: [QueryFilter]!, $offset: Int, $sort: QuerySort) {
  query(filters: $filters, offset: $offset, sort: $sort) {
    total
    data {
      id
      platform
      name
      url
      imageUrl
      rating
      address
      krunshScore
      categories
      firstSeenAt
      lastRefreshedAt
      currencyCode
      currencySymbol
      promotionCount
      deliveryTime
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.QueryQueryVariables, APITypes.QueryQuery>;
export const getMapPins =
  /* GraphQL */ `query GetMapPins($filters: [QueryFilter]!, $offset: Int) {
  getMapPins(filters: $filters, offset: $offset) {
    total
    data {
      id
      name
      imageUrl
      address
      platform
      rating
      deliveryTime
      krunshScore
      position {
        latitude
        longitude
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetMapPinsQueryVariables,
    APITypes.GetMapPinsQuery
  >;
export const getRestaurantDetails = /* GraphQL */ `query GetRestaurantDetails(
  $id: ID!
  $nearbyRadius: NearbyRadius
  $nearbyTagsInCommon: Int
  $tagsExactMatch: [String]
) {
  getRestaurantDetails(
    id: $id
    nearbyRadius: $nearbyRadius
    nearbyTagsInCommon: $nearbyTagsInCommon
    tagsExactMatch: $tagsExactMatch
  ) {
    id
    platform
    name
    phone
    email
    url
    currencyCode
    currencySymbol
    imageUrl
    position {
      latitude
      longitude
      __typename
    }
    rating
    ratingCount
    fulfillmentTypes
    address
    krunshScore
    krunshScoreDetails {
      ratingCount {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      productImages {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      rating {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      deliveryTime {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      productAvailability {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      __typename
    }
    nearbyIndex
    nearbyRestaurants {
      averageRating
      averageScore
      averageDeliveryTime
      restaurants {
        index
        id
        name
        address
        promotionCount
        position {
          latitude
          longitude
          __typename
        }
        imageUrl
        categories
        krunshScore
        distance
        platform
        rating
        deliveryTime
        __typename
      }
      __typename
    }
    categories
    firstSeenAt
    lastRefreshedAt
    hasPromotion
    openingHours {
      day
      startTime
      endTime
      menuName
      __typename
    }
    menuItems {
      id
      name
      price
      description
      categoryName
      imageUrl
      isSoldOut
      __typename
    }
    deliveryTime
    promotionCount
    promotions {
      type
      minValue
      itemId
      buyCount
      freeCount
      discount
      maxDiscount
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRestaurantDetailsQueryVariables,
  APITypes.GetRestaurantDetailsQuery
>;
export const getRestaurantOverview =
  /* GraphQL */ `query GetRestaurantOverview($id: ID!) {
  getRestaurantOverview(id: $id) {
    id
    platform
    name
    imageUrl
    address
    krunshScore
    nearbyIndex
    nearbyRestaurants {
      averageRating
      averageScore
      averageDeliveryTime
      restaurants {
        index
        id
        name
        address
        promotionCount
        position {
          latitude
          longitude
          __typename
        }
        imageUrl
        categories
        krunshScore
        distance
        platform
        rating
        deliveryTime
        __typename
      }
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetRestaurantOverviewQueryVariables,
    APITypes.GetRestaurantOverviewQuery
  >;
export const autocomplete = /* GraphQL */ `query Autocomplete($value: String!) {
  autocomplete(value: $value) {
    type
    value
    id
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AutocompleteQueryVariables,
  APITypes.AutocompleteQuery
>;
export const autocompleteCategory =
  /* GraphQL */ `query AutocompleteCategory($value: String!) {
  autocompleteCategory(value: $value) {
    type
    value
    id
    __typename
  }
}
` as GeneratedQuery<
    APITypes.AutocompleteCategoryQueryVariables,
    APITypes.AutocompleteCategoryQuery
  >;
export const autocompleteCity =
  /* GraphQL */ `query AutocompleteCity($value: String!) {
  autocompleteCity(value: $value) {
    type
    value
    id
    __typename
  }
}
` as GeneratedQuery<
    APITypes.AutocompleteCityQueryVariables,
    APITypes.AutocompleteCityQuery
  >;
export const autocompleteCountry =
  /* GraphQL */ `query AutocompleteCountry($value: String!) {
  autocompleteCountry(value: $value) {
    type
    value
    id
    __typename
  }
}
` as GeneratedQuery<
    APITypes.AutocompleteCountryQueryVariables,
    APITypes.AutocompleteCountryQuery
  >;
export const autocompleteRestaurant =
  /* GraphQL */ `query AutocompleteRestaurant($value: String!) {
  autocompleteRestaurant(value: $value) {
    name
    imageUrl
    address
    id
    platform
    krunshScore
    rating
    deliveryTime
    __typename
  }
}
` as GeneratedQuery<
    APITypes.AutocompleteRestaurantQueryVariables,
    APITypes.AutocompleteRestaurantQuery
  >;
export const getSearchHistory = /* GraphQL */ `query GetSearchHistory {
  getSearchHistory {
    date
    term
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSearchHistoryQueryVariables,
  APITypes.GetSearchHistoryQuery
>;
export const getRestaurantHistory = /* GraphQL */ `query GetRestaurantHistory {
  getRestaurantHistory {
    id
    platform
    name
    url
    imageUrl
    position {
      latitude
      longitude
      __typename
    }
    rating
    address
    krunshScore
    categories
    firstSeenAt
    lastRefreshedAt
    currencyCode
    currencySymbol
    promotionCount
    deliveryTime
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRestaurantHistoryQueryVariables,
  APITypes.GetRestaurantHistoryQuery
>;
export const getUserRestaurants = /* GraphQL */ `query GetUserRestaurants {
  getUserRestaurants {
    id
    platform
    name
    url
    imageUrl
    position {
      latitude
      longitude
      __typename
    }
    rating
    address
    krunshScore
    categories
    firstSeenAt
    lastRefreshedAt
    currencyCode
    currencySymbol
    promotionCount
    deliveryTime
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserRestaurantsQueryVariables,
  APITypes.GetUserRestaurantsQuery
>;
export const getNumberOfAddressesForUserRestaurants =
  /* GraphQL */ `query GetNumberOfAddressesForUserRestaurants {
  getNumberOfAddressesForUserRestaurants
}
` as GeneratedQuery<
    APITypes.GetNumberOfAddressesForUserRestaurantsQueryVariables,
    APITypes.GetNumberOfAddressesForUserRestaurantsQuery
  >;
export const getNumberOfAddressesAfterRemovingUserRestaurant =
  /* GraphQL */ `query GetNumberOfAddressesAfterRemovingUserRestaurant($restaurantIds: [ID]!) {
  getNumberOfAddressesAfterRemovingUserRestaurant(restaurantIds: $restaurantIds)
}
` as GeneratedQuery<
    APITypes.GetNumberOfAddressesAfterRemovingUserRestaurantQueryVariables,
    APITypes.GetNumberOfAddressesAfterRemovingUserRestaurantQuery
  >;
export const getFavoriteLists = /* GraphQL */ `query GetFavoriteLists {
  getFavoriteLists {
    id
    name
    restaurantCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetFavoriteListsQueryVariables,
  APITypes.GetFavoriteListsQuery
>;
export const getRestaurantsInFavoriteList =
  /* GraphQL */ `query GetRestaurantsInFavoriteList($favoriteListId: ID!) {
  getRestaurantsInFavoriteList(favoriteListId: $favoriteListId) {
    id
    platform
    name
    url
    imageUrl
    position {
      latitude
      longitude
      __typename
    }
    rating
    address
    krunshScore
    categories
    firstSeenAt
    lastRefreshedAt
    currencyCode
    currencySymbol
    promotionCount
    deliveryTime
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetRestaurantsInFavoriteListQueryVariables,
    APITypes.GetRestaurantsInFavoriteListQuery
  >;
export const getRestaurantCharts =
  /* GraphQL */ `query GetRestaurantCharts($id: ID!, $length: HistoryLength) {
  getRestaurantCharts(id: $id, length: $length) {
    krunshScore {
      date
      value
      __typename
    }
    rating {
      date
      value
      __typename
    }
    numberOfRatings {
      date
      value
      __typename
    }
    deliveryTime {
      date
      value
      __typename
    }
    ranking {
      date
      value
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetRestaurantChartsQueryVariables,
    APITypes.GetRestaurantChartsQuery
  >;
export const getCurrentSubscription =
  /* GraphQL */ `query GetCurrentSubscription {
  getCurrentSubscription {
    productId
    priceId
    currentPeriodStart
    currentPeriodEnd
    cancelAtPeriodEnd
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetCurrentSubscriptionQueryVariables,
    APITypes.GetCurrentSubscriptionQuery
  >;
export const getEntitlements = /* GraphQL */ `query GetEntitlements {
  getEntitlements {
    name
    count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEntitlementsQueryVariables,
  APITypes.GetEntitlementsQuery
>;
export const listProducts = /* GraphQL */ `query ListProducts {
  listProducts {
    name
    description
    marketingFeatures
    prices {
      id
      lookupKey
      price
      currency
      interval
      taxBehavior
      __typename
    }
    defaultPrice
    isRecurring
    isCreditPack
    creditPackInfo {
      count
      popular
      __typename
    }
    isMainSubscription
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductsQueryVariables,
  APITypes.ListProductsQuery
>;
export const listInvoices = /* GraphQL */ `query ListInvoices($after: ID) {
  listInvoices(after: $after) {
    invoices {
      id
      amount
      createdAt
      status
      invoiceUrl
      invoicePdfUrl
      __typename
    }
    hasMore
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListInvoicesQueryVariables,
  APITypes.ListInvoicesQuery
>;
export const getRemainingKrunshCredits =
  /* GraphQL */ `query GetRemainingKrunshCredits {
  getRemainingKrunshCredits
}
` as GeneratedQuery<
    APITypes.GetRemainingKrunshCreditsQueryVariables,
    APITypes.GetRemainingKrunshCreditsQuery
  >;
export const getNotifications = /* GraphQL */ `query GetNotifications {
  getNotifications {
    ... on KrunshScoreNotification {
      id
      restaurantId
      type
      isRead
      createdAt
      oldScore
      newScore
      __typename
    }
    ... on NewRestaurantsNotification {
      id
      restaurantId
      type
      isRead
      createdAt
      newRestaurantIds
      __typename
    }
    ... on RatingNotification {
      id
      restaurantId
      type
      isRead
      createdAt
      oldRating
      newRating
      __typename
    }
    ... on NumberOfRatingsNotification {
      id
      restaurantId
      type
      isRead
      createdAt
      oldNumberOfRatings
      newNumberOfRatings
      __typename
    }
    ... on RankingNotification {
      id
      restaurantId
      type
      isRead
      createdAt
      oldRanking
      oldRanking7D
      oldRanking28D
      newRanking
      totalCount
      __typename
    }
    ... on NearbyPromotionCountNotification {
      id
      restaurantId
      type
      isRead
      createdAt
      oldNearbyPromotionCount
      newNearbyPromotionCount
      restaurantIds
      __typename
    }
    ... on NearbyAveragePriceNotification {
      id
      restaurantId
      type
      isRead
      createdAt
      oldNearbyAveragePrice
      newNearbyAveragePrice
      __typename
    }
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationsQueryVariables,
  APITypes.GetNotificationsQuery
>;
export const getGrids = /* GraphQL */ `query GetGrids {
  getGrids {
    id
    name
    columns
    restaurantCount
    emails
    frequency
    __typename
  }
}
` as GeneratedQuery<APITypes.GetGridsQueryVariables, APITypes.GetGridsQuery>;
export const getRestaurantsInGrid =
  /* GraphQL */ `query GetRestaurantsInGrid($gridId: ID!, $offset: Int) {
  getRestaurantsInGrid(gridId: $gridId, offset: $offset) {
    total
    data {
    id
    platform
    name
    url
    currencyCode
    currencySymbol
    imageUrl
    position {
      latitude
      longitude
      __typename
    }
    rating
    ratingCount
    fulfillmentTypes
    address
    krunshScore
    krunshScoreDetails {
      ratingCount {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      productImages {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      rating {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      deliveryTime {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      productAvailability {
        value
        badge,
        text {
          title,
          type,
          items
        }
      }
      __typename
    }
    nearbyIndex
    nearbyRestaurants {
      averageRating
      averageScore
      averageDeliveryTime
      restaurants {
        index
        id
        name
        address
        promotionCount
        position {
          latitude
          longitude
          __typename
        }
        imageUrl
        categories
        krunshScore
        distance
        platform
        rating
        deliveryTime
        __typename
      }
      __typename
    }
    categories
    firstSeenAt
    lastRefreshedAt
    hasPromotion
    openingHours {
      day
      startTime
      endTime
      menuName
      __typename
    }
    menuItems {
      id
      name
      price
      description
      categoryName
      imageUrl
      isSoldOut
      __typename
    }
    deliveryTime
    promotionCount
    promotions {
      type
      minValue
      itemId
      buyCount
      freeCount
      discount
      maxDiscount
      __typename
    }
    __typename
  }
    __typename
  }
}
` as GeneratedQuery<
    APITypes.GetRestaurantsInGridQueryVariables,
    APITypes.GetRestaurantsInGridQuery
  >;
